import { useBundle } from "../context/BundleContext";
import { ReceiptPanel } from "../components/receipt/ReceiptPanel";
import { VariantLedger } from "../components/receipt/VariantLedger";
import { VerificationResult } from "../components/receipt/VerificationResult";
import { IntelligenceAttestation } from "../components/receipt/IntelligenceAttestation";
import { AnchorRiskIntelligence } from "../components/receipt/AnchorRiskIntelligence";
import { EmptyState } from "../components/shell/EmptyState";
import { anchorWalletForCase } from "../lib/cases";

export function ReceiptRoute() {
  const bundle = useBundle();
  const anchorWallet = anchorWalletForCase(bundle.overview.caseId);
  const hasExternalIntelligence = bundle.intelligence !== undefined || anchorWallet !== undefined;

  return (
    <div className="mx-auto max-w-4xl space-y-10 px-6 py-12">
      <h1 className="font-editorial text-3xl text-ink">Fix receipt</h1>

      <ReceiptPanel receipt={bundle.receipt} artifactIndex={bundle.artifactIndex} />

      <VariantLedger ledger={bundle.variantLedger} />

      <section aria-labelledby="verification-heading">
        <h2 id="verification-heading" className="font-editorial text-xl text-ink">
          Independent verification
        </h2>
        <p className="mt-2 text-sm text-ink-muted">
          Re-derived from the bytes on disk, not trusted from the receipt's own claims (see{" "}
          <code className="font-evidence">@exploitlens/verifier</code>). The second result below
          demonstrates what a real, deliberately tampered bundle produces.
        </p>
        <div className="mt-4 space-y-4">
          {bundle.verification ? (
            <VerificationResult result={bundle.verification} />
          ) : (
            <EmptyState title="No verification result was shipped for the committed bundle." />
          )}
          {bundle.tamperedVerification ? (
            <VerificationResult result={bundle.tamperedVerification} />
          ) : (
            <EmptyState title="No tamper-detection demonstration was shipped with this bundle." />
          )}
        </div>
      </section>

      {hasExternalIntelligence && (
        <section aria-labelledby="intelligence-heading">
          <h2 id="intelligence-heading" className="font-editorial text-xl text-ink">
            External intelligence
          </h2>
          <p className="mt-2 text-sm text-ink-muted">
            Everything above this line is the verdict, decided entirely by real Foundry execution
            and deterministic comparison. What follows is optional, external, and separate --
            included for context, never as evidence the verdict relies on.
          </p>
          <div className="mt-4 space-y-4">
            {bundle.intelligence && <IntelligenceAttestation attestation={bundle.intelligence} />}
            {anchorWallet && <AnchorRiskIntelligence wallet={anchorWallet} />}
          </div>
        </section>
      )}
    </div>
  );
}
